import { API_ORDERS_ORIGIN } from '@src/config/env'
import { useCallback, useEffect } from 'react'
import styled from 'styled-components'
import useBearerFetch from '../../../hooks/useBearerFetch'
import { desktopVw, mobileVw } from '../../../styles/utils'
import Button from '../../Button'
import SpinningLoader from '../../SpinningLoader'
import Drawer from '../../common/Drawer'
import EditAddress from '../EditShippingAdress'
import styles from './editShippingAddressWrapper.module.scss'
import { useTranslation } from 'next-i18next'

const getOrderFetchUrl = orderId => `${API_ORDERS_ORIGIN}/service/v2/customer/orders/${orderId}`

const ORDER_FETCH_OPTIONS = {
  // @i18n-ignore
  method: 'GET',
  headers: {
    // @i18n-ignore
    'Content-Type': 'application/json',
  },
}

const Wrapper = styled.div`
  .side__modal__container {
    padding: ${mobileVw(48)} ${mobileVw(18)} ${mobileVw(48)} ${mobileVw(24)};
    @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
      padding: ${desktopVw(33)} ${desktopVw(0)} ${desktopVw(33)} ${desktopVw(40)};
      width: ${desktopVw(456)};
    }
  }
`

const EditAddressSideDrawer = props => {
  const { t } = useTranslation('common')
  const { open, closeModal, activeOrder } = props
  const { fetchData, response, loading, error } = useBearerFetch()
  const orderId = activeOrder?.orderId || activeOrder?.id

  const loadOrder = useCallback(() => {
    if (orderId) {
      const orderFetchUrl = getOrderFetchUrl(orderId)
      fetchData(orderFetchUrl, ORDER_FETCH_OPTIONS)
    }
  }, [fetchData, orderId])

  useEffect(() => {
    loadOrder()
  }, [loadOrder])

  return (
    <Wrapper>
      <Drawer open={open} onClose={closeModal} hideClose>
        {loading ? <SpinningLoader /> : null}
        {!loading && error ? (
          <div className={styles.errorContainer}>
            <p>{t('failed_to_retrieve_order')}</p>
            <Button className={styles.retryButton} onClick={loadOrder}>
              {t('retry')}
            </Button>
          </div>
        ) : null}
        {!loading && response ? <EditAddress {...props} activeOrder={response} onBeforeSubmit={props.onBeforeSubmit} /> : null}
      </Drawer>
    </Wrapper>
  )
}

export default EditAddressSideDrawer
